import { useEffect } from "react";
import {
  AsyncSimpleSelectV2,
  CardRouded,
  ContainerV2,
  H1,
  P,
} from "../../Atoms";
import { useSearchClient } from "./useSearchClient";
import { Tracking } from "../../../services/Tracking";

export const SearchClients = () => {
  const { getClient, client, setClient, handleContinue, handleSelect } =
    useSearchClient();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/buscar-cliente:pageview");
  });

  function NoOptionsMessageContent() {
    return (
      <div className="flex flex-col items-center justify-center gap-4 p-4">
        <img src="/assets/svgs/icon-user-search.svg" alt="icone usuario" />
        <P className="text-base font-bold">Nenhum cliente encontrado</P>
        <button
          className="flex gap-2 items-center text-[#20332F] text-sm font-bold rounded-[100px] bg-[rgba(32,51,47,0.05)] px-5 py-3"
          onClick={() => handleContinue()}
        >
          <img
            src="/assets/svgs/icon-plus-circle.svg"
            alt="icone adicionar cliente"
          />{" "}
          Cadastrar novo cliente
        </button>
      </div>
    );
  }

  return (
    <ContainerV2
      nextButton={{
        title: "Selecionar",
        type: "submit",
        disabled: !client?.uuid,
        onClick: handleSelect,
      }}
    >
      <div>
        <H1 className="mb-4">Cliente referente ao agendamento</H1>
        <P className="mb-8">Selecione o cliente responsável pelo veículo.</P>

        <CardRouded>
          <AsyncSimpleSelectV2
            variant="search"
            placeholder=""
            autoFocus
            label="Nome ou CPF/CNPJ"
            loadOptions={getClient}
            onChange={(e) => setClient(e?.element)}
            noOptionsMessage={() => <NoOptionsMessageContent />}
          />
        </CardRouded>
      </div>
    </ContainerV2>
  );
};
